<template>
  <div>
    <ul v-show="menuVisible" :style="menuStyle" class="contextmenu">
      <slot name="menuList"></slot>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'Contextmenu',
  props: {
    activeRows: {
      type: Object
    },
    append: {
      type: String,
      default: 'body'
    },
    offsetX: {
      type: Number,
      default: 0
    },
    offsetY: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      menuVisible: false,
      top: 0,
      left: 0
    }
  },
  watch: {
    menuVisible(value) {
      if (value) {
        document.body.addEventListener('click', this.closeMenu)
      } else {
        document.body.removeEventListener('click', this.closeMenu)
      }
    }
  },
  mounted() {},
  destroyed() {},
  computed: {
    menuStyle() {
      return {
        left: this.left + 'px',
        top: this.top + 'px'
      }
    }
  },
  methods: {
    openMenu(row, column, event) {
      if (event.type === 'click') {
        if (window.outerWidth < 500) {
          this.handleOpen()
        }
      } else {
        this.handleOpen(event)
      }
    },
    handleOpen(event) {
      this.menuVisible = true
      
      // 使用 clientX 和 clientY 来获取相对于视口的坐标
      const left = event.clientX
      const top = event.clientY
      
      // 获取菜单元素
      const menuElement = this.$el.getElementsByClassName('contextmenu')[0]
      const menuHeight = menuElement ? menuElement.offsetHeight : 0
      const menuWidth = menuElement ? menuElement.offsetWidth : 0
      
      // 获取视口尺寸
      const viewportHeight = window.innerHeight
      const viewportWidth = window.innerWidth
      
      // 计算最终位置，确保菜单不会超出视口
      let finalLeft = left
      let finalTop = top
      
      // 如果菜单会超出右边界，向左偏移
      if (left + menuWidth > viewportWidth) {
        finalLeft = viewportWidth - menuWidth
      }
      
      // 如果菜单会超出下边界，向上偏移
      if (top + menuHeight > viewportHeight) {
        finalTop = top - menuHeight
      }
      
      this.left = finalLeft
      this.top = finalTop
      
      event.returnValue = false
    },
    closeMenu() {
      this.menuVisible = false
    }
  }
}
</script>

<style scoped>
.contextmenu {
  position: fixed;
  background: #fff;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
  padding: 5px 0;
  z-index: 9999;
  margin: 0;
  list-style: none;
}

.contextmenu li {
  padding: 5px 15px;
  font-size: 12px;
  line-height: 20px;
  min-width: 130px;
  cursor: pointer;
  list-style: none;
  margin: 0;
}

.contextmenu li:hover {
  background-color: #f5f7fa;
}
</style>
